import logo from './logo.svg';
import { Routes, Route } from 'react-router-dom';
import Home from './screen/Home';
import { HomeContext,HomeProvider } from './screen/Home/HomeContext';
import { AdminContext,AdminProvider } from './screen/Admin/AdminContext';
import { ProductContext,ProductProvider } from './screen/Product/ProductContext';
import { ProdDetailPageContext,ProdDetailPageProvider } from './screen/Product/ProdDetailPage/ProdDetailPageContext';

import MyPage from './UICompToolkit/MyPage';
import React,{useEffect,useState} from 'react';
import Product from './screen/Product';
import ProdDetailPage from './screen/Product/ProdDetailPage';
import {Login} from './UICompToolkit/LoginView';
import Pay from './Pay';
import ReturnPay from './ReturnPay';
import Store from './screen/Store';
import Programming from './screen/Programming';
import Graphics from './screen/Graphics';
import DataBase from './screen/DataBase';
import DevOps from './screen/DevOps';
import Infra from './screen/Infra';
import Cart from './screen/Cart';
import Admin from './screen/Admin';
import AgentSubmissions from './screen/Admin/AgentSubmissions';
import Popup from './UICompToolkit/LoginBox';
import { AuthContext, useAuth } from "./authContext";

import { RegisterForm } from './UICompToolkit/RegisterForm';
import { Header } from './components/Header';
import ProductRegistration from './screen/ProductRegistration';
import CourseDetail from './screen/CourseLibrary/CourseDetail';
import CourseEdit from './screen/CourseLibrary/CourseEdit';
import CourseLibrary from './screen/CourseLibrary';
import Market from './screen/Market';
import Checkout, { PaymentReturn } from './screen/Market/Checkout';
import Classroom from './screen/Classroom';
import CoursePurchase from './screen/Classroom/Purchase';
import CoursePurchases from './screen/Classroom/Purchases';
import CourseCatalog from './screen/Classroom/Catalog';

function App() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const { login, user } = useAuth();
  
  return (
    <>
      <div className="App">
        <Header/>
        <Routes>
          <Route path="/Courses" element={<CourseCatalog/>}/>
          <Route path="/Classroom" element={<Classroom/>}/>
          <Route path="/Classroom/:courseId" element={<Classroom/>}/>
          <Route path="/Classroom/:courseId/:lessonId" element={<Classroom/>}/>
          <Route path="/ClassroomPurchases" element={<CoursePurchases/>}/>
          <Route path="/Learn/:productId" element={<CoursePurchase/>}/>
          <Route path="/Admin/agent-submissions" element={<AgentSubmissions />} />
          <Route path="/Market" element={<Market />} />
          <Route path="/Checkout" element={<Checkout />} />
          <Route path="/Market/payment" element={<PaymentReturn />} />
          <Route exact path="/Home" element={<HomeProvider><Home /></HomeProvider>} key="Home" />
          <Route exact path="/Login" element={<Login/>} key="Login" /> 
          <Route exact path="/Cart" element={<Cart />} key="Cart" />
          <Route exact path="/" element={<Store />} key="Store" />
          <Route path="/course-library/:type" element={<CourseLibrary />} key="CourseLibrary" />
          <Route exact path="/Product" element={<ProductProvider><Product /></ProductProvider>} key="Product" />
          <Route exact path="/ProdDetailPage" element={<ProdDetailPageProvider><ProdDetailPage/></ProdDetailPageProvider>} key="ProdDetailPage" />
          <Route exact path="/MyPage" element={<HomeProvider><MyPage/></HomeProvider>} key="MyPage" />
          <Route exact path="/Admin" element={<AdminProvider><Admin/></AdminProvider>} key="Admin" />
          <Route exact path="/Register" element={<HomeProvider><RegisterForm/></HomeProvider>} key="Register" />
          <Route exact path="/upload" element={<HomeProvider><ProductRegistration /></HomeProvider>} key="ProductRegister" />
          <Route path="/CourseDetail/:productId" element={<HomeProvider><CourseDetail/></HomeProvider>} />
          <Route path="/edit" element={<HomeProvider><CourseEdit/></HomeProvider>} key="CourseEdit" />
          <Route exact path="/Pay" element={<HomeProvider><Pay /></HomeProvider>} key="Pay" />
          <Route exact path="/ReturnPay" element={<HomeProvider><ReturnPay /></HomeProvider>} key="ReturnPay" />
        </Routes>
      </div>
    </>
  );
}

export default App;
